export default(state = {
    radius: 128,
    widthSegments: 48,
    heightSegments: 32,
    seed: Date.now(),
    noiseWidth: 32,
    noiseHeight: 8
}, action) => {
    switch (action.type) {
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/portfolio/battle-royale/reducers/planet.js